<template>
    <div>
        <nav class="navbar navbar-expand-md fixed-top">
            <div class="col-4">
                <router-link to="/home">
                    <img class="logo-img" id="logo-btn" src="images/logo.png" />
                </router-link>
            </div>
            <div class="col-8">
                <div class="app navigation">
                     <a class="apply-btn">Apply Now</a>
                    <TopMenu></TopMenu>
                </div>
            </div>
        </nav>
        <div class="main app">
            <div class="container-fluid wrapper">
                <div class="row reg-box">
                    <div class="col-3">
                        <div class="left-bg">
                            
                        </div>
                    </div>
                    <div class="col-1">

                    </div>
                    <div class="col-8">
                        <div class="document top98 fullsize">
                            <h2>IMPORTANT NOTICE:</h2>
                            <p>Visa applicant is assumed to have read, understood, and agreed to the terms and conditions stipulated in the Visa Terms and Guidelines</p>
                            <p>Applicants must ensure that their passports have a validity of at least six months and at least three unused visa pages before submitting their application</p>
                            <p>Applicant is expected to apply for a right category of visa</p>
                            <p>Any visa wrongly applied may be rejected</p>
                            <p>No refund will be made in respect of any rejected visa application</p>
                            <p>After submitting application, applicants are required to wait for approval of their Visa before they start their journey. Approval notification will be available on the site online</p>
                            <p>The list of countries that nor require visa may change at any time; therefore, applicants are advised to review our website from time to time</p>
                            <p>Visa regulations and conditions may be subject to change at any time without prior notification to the applicants</p>
                            <div class="submit-row floatLeft top64">
                                
                              <button @click="$router.go(-1)" type="button" class="btn-submit">Back</button>
                         
                            </div>
                       
                          
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>


<script>

    import TopMenu from "./Menu";
    export default {
        components: { TopMenu },
        name: 'VisaProcess',

        model: {},
        data: () => ({

        }),
        mounted() {
           

        },
        computed: {

        },
        methods: {
        }
    }
</script>
